var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEspeciesParaguas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_especies_paraguas",
    "data-name": "ico_especies paraguas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_59",
    "data-name": "Rect\\xE1ngulo 59",
    width: 100,
    height: 100,
    fill: "#f2b229"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_89",
    "data-name": "Grupo 89",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_248",
    "data-name": "Trazado 248",
    d: "M163.477,122.577h0a27.1,27.1,0,0,0-9.946,12.348c-2.659,6.994-8.527,8.125-12.039,7.7a36.515,36.515,0,0,1-2.656,5.437c.953,0,1.906,0,2.839,0h.424a25.635,25.635,0,0,0,25.426-21.341c.03-.166.046-.358.063-.561a5.319,5.319,0,0,1,.283-1.491V122.61a1.1,1.1,0,0,0-.437-.048c-1.321.024-2.658.019-3.951.015",
    transform: "translate(-82.507 -72.838)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_249",
    "data-name": "Trazado 249",
    d: "M79.67,115.767c2.349-2.488,4.285-7.923,4.3-7.977l.368-1.041,1.073.265c.294.07,7.338,1.662,10.252-6a28.867,28.867,0,0,1,8.2-11.486l-39.08,0a8.608,8.608,0,0,1-8.6-7.311A1.889,1.889,0,0,1,57.2,80.071a12.449,12.449,0,0,0,2.519-1.763c1.28-1.164,2.158-2.2,2.283-3.479a53.4,53.4,0,0,0,.085-6.685q-.018-.6-.033-1.2l-.037,0a10.131,10.131,0,0,0-5.193,1.977,9.156,9.156,0,0,0-2.285,2.615L53.447,73.3,52.441,71.49a8.663,8.663,0,0,0-6.811-4.48,1.727,1.727,0,0,0-.3-.021,1.61,1.61,0,0,0-.02.27q-.009,3.522,0,7.043a1.279,1.279,0,0,0,.028.349,10.674,10.674,0,0,0,2.728,4.608,2.475,2.475,0,0,1,.827,1.955c-.034,3.292-.056,6.821-.068,11.107l0,.353a10.608,10.608,0,0,0,.048,1.379c8.746,11.645,23.912,12.623,24.066,12.631l.987.055.149.977c.063.416.5,4.177-3.432,9.106-.415.848-.81,1.712-1.191,2.549a1.38,1.38,0,0,0-.08.217,1.329,1.329,0,0,0,.206.03,11.541,11.541,0,0,0,10.076-3.829l.022-.022Z",
    transform: "translate(-26.922 -39.787)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_250",
    "data-name": "Trazado 250",
    d: "M79.411,156.812c-3.315-.383-13.245-2.113-21.111-9.437a24.642,24.642,0,0,0,4.991,7.227,27.067,27.067,0,0,0,13.847,7.559,12.908,12.908,0,0,0,2.272-5.349",
    transform: "translate(-34.647 -87.584)",
    fill: "#f2b229"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_251",
    "data-name": "Trazado 251",
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0M87.668,52.612a2.753,2.753,0,0,0-.166.908c-.02.237-.043.506-.092.783a28.069,28.069,0,0,1-27.815,23.35h-.424c-1.521,0-3.094.009-4.645-.008a13.8,13.8,0,0,1-10.679,4.666q-.675,0-1.374-.052A2.583,2.583,0,0,1,40.3,81.076a2.61,2.61,0,0,1,.006-2.5c.27-.594.546-1.2.834-1.811A29.411,29.411,0,0,1,26.91,68.727a26.552,26.552,0,0,1-7.316-13.733,10.313,10.313,0,0,1-.13-2.129l0-.337c.012-4.292.034-7.827.068-11.125a.625.625,0,0,0-.006-.1s-.019-.02-.049-.048a12.98,12.98,0,0,1-3.375-5.614,3.511,3.511,0,0,1-.154-1.116q-.01-3.527,0-7.055a2.691,2.691,0,0,1,.834-2.136,2.739,2.739,0,0,1,2.272-.516,11.24,11.24,0,0,1,7.562,4.146,10.211,10.211,0,0,1,1.831-1.771,12.664,12.664,0,0,1,6.4-2.448,2.543,2.543,0,0,1,1.942.59,2.285,2.285,0,0,1,.769,1.679c.01.425.023.85.035,1.276a55.2,55.2,0,0,1-.1,6.994c-.213,2.173-1.6,3.708-3.068,5.042a14.789,14.789,0,0,1-2.728,1.954,6.123,6.123,0,0,0,6.156,5.029l41.549,0q.783,0,1.566,0c1.28,0,2.6.009,3.9-.014a2.8,2.8,0,0,1,2.781,1.518l.133.261v3.288Z",
    fill: "#f2b229"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEspeciesParaguas);
export default __webpack_public_path__ + "static/media/ico_especies_paraguas.560cc73d72f9da73f7ed8e0f21e2bc97.svg";
export { ForwardRef as ReactComponent };